<template>
  <KTCodePreview v-bind:title="'Cấu hình kiểm soát truy cập IP'">
    <template v-slot:preview>
      <b-tabs
        v-model="activeTab"
        content-class="mt-3"
        nav-class="border-bottom"
        @input="onTabChange"
      >
        <b-tab title="IP được phép">
          <TabWhitelist v-if="activeTab === 0" />
        </b-tab>
        <b-tab title="Ngoại lệ bypass">
          <TabBypass v-if="activeTab === 1" />
        </b-tab>
      </b-tabs>
    </template>
  </KTCodePreview>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import KTCodePreview from '@/view/content/CodePreview.vue';
import TabWhitelist from './TabWhitelist.vue';
import TabBypass from './TabBypass.vue';

const TAB_MAP = { whitelist: 0, bypass: 1 };
const TAB_NAMES = ['whitelist', 'bypass'];

export default {
  name: 'AccessSettingsIndex',
  components: { KTCodePreview, TabWhitelist, TabBypass },
  data() {
    return {
      activeTab: 0,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Cấu hình', route: '/settings' },
      { title: 'Kiểm soát truy cập IP' },
    ]);
    const tab = this.$route.query.tab;
    if (tab && TAB_MAP[tab] !== undefined) {
      this.activeTab = TAB_MAP[tab];
    }
  },
  methods: {
    onTabChange(index) {
      const tabName = TAB_NAMES[index] || 'whitelist';
      this.$router.replace({ query: { ...this.$route.query, tab: tabName } }).catch(() => {});
    },
  },
};
</script>
